import Cookies from 'js-cookie';

const COOKIE_NAME = 'email';

export const getEmail = () => Cookies.get(COOKIE_NAME);
export const setEmail = (email: string) => Cookies.set(COOKIE_NAME, email);
export const removeEmail = () => Cookies.remove(COOKIE_NAME);
